// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"5043":"a4fc9f91","5674":"d691b6fd","7950":"e88b91b4"}[chunkId] + ".chunk.js";
};